import { observable, action } from "mobx";
import makeApi, { URLS } from "Utils/apiURL";
import { BULK_TASKS_OPERATION_DATE } from "Static/constant";

export const BULK_NOTIFICATION_OPEN_STATUSES = [
  "TO_BE_PROCESSED",
  "IN_PROGRESS"
];

const MAX_VISIBLE_JOBS = 5;
const FETCH_LIMIT = 100;

const sortJobsByCreateTs = (jobs = []) => {
  return [...jobs].sort((left, right) => {
    const leftTs = left?.createTs ? new Date(left.createTs).getTime() : 0;
    const rightTs = right?.createTs ? new Date(right.createTs).getTime() : 0;
    return rightTs - leftTs;
  });
};

class BulkJobsNotificationStore {
  @observable jobs = [];
  @observable openJobsCount = 0;
  @observable loading = false;
  @observable guideVisible = false;
  @observable highlightActive = false;
  @observable guideMessage = "Track your bulk jobs here";

  guideTimer = null;
  highlightTimer = null;

  @action
  setJobs = (jobs = []) => {
    const sortedJobs = sortJobsByCreateTs(jobs);
    this.jobs = sortedJobs.slice(0, MAX_VISIBLE_JOBS);
    this.openJobsCount = sortedJobs.filter(job =>
      BULK_NOTIFICATION_OPEN_STATUSES.includes(job?.status)
    ).length;
  };

  @action
  setLoading = (value = false) => {
    this.loading = value;
  };

  @action
  setGuideVisible = (value = false) => {
    this.guideVisible = value;
  };

  @action
  setHighlightActive = (value = false) => {
    this.highlightActive = value;
  };

  @action
  dismissGuide = () => {
    if (this.guideTimer) {
      clearTimeout(this.guideTimer);
      this.guideTimer = null;
    }
    if (this.highlightTimer) {
      clearTimeout(this.highlightTimer);
      this.highlightTimer = null;
    }
    this.setGuideVisible(false);
    this.setHighlightActive(false);
  };

  @action
  triggerGuide = (message = "Track your bulk jobs here") => {
    this.dismissGuide();
    this.guideMessage = message;
    this.setGuideVisible(true);
    this.setHighlightActive(true);

    this.highlightTimer = setTimeout(() => {
      this.setHighlightActive(false);
    }, 4500);

    this.guideTimer = setTimeout(() => {
      this.setGuideVisible(false);
    }, 6500);
  };

  fetchJobs = async (limit = FETCH_LIMIT) => {
    try {
      this.setLoading(true);
      const response = await makeApi({
        url: URLS.tasksOperationLogs,
        method: "POST",
        data: {
          limit,
          pageNo: 1,
          date: BULK_TASKS_OPERATION_DATE
        }
      });
      if (response?.data?.jobs) {
        this.setJobs(response.data.jobs || []);
      }
    } catch (error) {
      console.error("Failed to fetch bulk jobs", error);
    } finally {
      this.setLoading(false);
    }
  };
}

const bulkJobsNotificationStore = new BulkJobsNotificationStore();

export default bulkJobsNotificationStore;
